import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Signup class utility/service.
 */

import RESTService from '../../api/RESTService';
import RESOURCE_NAMES from '../../api/resources';
/**
 * Calls the REST API that generates a temporary user account.
 *
 * @param {function} callback callback function to execute afterwards
 */

var createTempUserUtil = function createTempUserUtil(callback) {
  var _context, _context2;

  var url = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "").call(_context2, process.env.REACT_APP_REST_URL, "/")).call(_context, RESOURCE_NAMES.generatedUserAccount);

  RESTService.post(url, {}, callback);
};
/**
 * Calls the REST API that creates a new account.
 *
 * @param {Object} data the user input data
 * @param {function} callback callback function to execute afterwards
 */


var postSignupDataUtil = function postSignupDataUtil(data, callback) {
  var _context3, _context4;

  var url = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "").call(_context4, process.env.REACT_APP_REST_URL, "/")).call(_context3, RESOURCE_NAMES.userAccount);

  RESTService.post(url, {
    username: data.showUsername ? data.username : data.emailAddress,
    password: data.password,
    confirm_password: data.password,
    secret_question_type: data.secretQuestionType,
    secret_question_answer: data.secretQuestionAnswer,
    first_name: data.firstName,
    middle_name: '',
    surname: data.surname,
    email_address: data.emailAddress,

    /* cspell:disable-next-line */
    is_terms_and_cond_accepted: data.termsAndConditionsAccepted
  }, callback);
};

export default {
  createTempUserUtil: createTempUserUtil,
  postSignupDataUtil: postSignupDataUtil
};